// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Pe1E","rightAdornment":"Header_rightAdornment__1Ze-I"};